import { postPfFile } from '@client-shared/api/pf-files.api.js'
import ClipboardFile from '@client-shared/models/clipboard-file.model.js'
import getErrorStatus from '@client-shared/utils/get-error-status.js'
import { Uppy } from '@uppy/core'
import { ObjectId } from 'bson'

export default {
  install: (app) => {
    const clipboardUppy = new Uppy({
      autoProceed: true,
      restrictions: {},
    })

    clipboardUppy
      .on('upload-error', (file, error) => {
        const {
          $auth, $store,
        } = app.config.globalProperties

        const responseStatusCode = getErrorStatus(error)

        if (responseStatusCode === 401 && $auth.loggedIn) {
          $store.commit('clipboard/REMOVE_FILE', file)

          return $auth.logout()
        }

        const uppyFile = clipboardUppy.store.state.files[file.id]

        if (!uppyFile) { return }

        $store.commit('clipboard/REPLACE_FILE', ClipboardFile.createFromUppyFile(uppyFile))
      })
      .on('upload-success', async (file, response) => {
        const uppyFile = clipboardUppy.store.state.files[file.id]
        const { $store, $axios } = app.config.globalProperties

        if (!uppyFile) { return }

        try {
          uppyFile.error = null

          const pfFileId = new ObjectId()
            .toString()
          const pfFile = await postPfFile({
            axios: $axios,
            _id: pfFileId,
            projectId: uppyFile.meta.projectId,
            s3Key: response.body.key,
            fileName: decodeURIComponent(uppyFile.name),
            mimeType: uppyFile.type,
            size: uppyFile.size,
            isClipboardFile: true,
          })

          $store.commit('pfFiles/ADD_PF_FILE', pfFile)

          uppyFile.pfFileId = pfFile._id

          $store.commit('clipboard/REPLACE_FILE', ClipboardFile.createFromUppyFile(uppyFile))
          $store.commit('clipboard/SET_FILTER', '')
          clipboardUppy.removeFile(uppyFile.id)
        } catch (err) {
          console.error('Failed to create pfFile for clipboard upload:', err)
          uppyFile.error = err.message || 'Failed to create pfFile'
          $store.commit('clipboard/REPLACE_FILE', ClipboardFile.createFromUppyFile(uppyFile))
        }
      })
      .on('upload-progress', file => {
        const $store = app.config.globalProperties.$store
        const storeFile = $store.state.clipboard.files.find(f => f.id === file.id)

        if (!storeFile) {
        // File can be empty, for example when file is uploaded in one tab, and removed in another tab (during upload)
          return
        }

        const storeFileProgress = storeFile.uploadPercentageDone
        const uppyFile = clipboardUppy.store.state.files[file.id]
        const uppyFileProgress = uppyFile.progress.percentage

        if (storeFileProgress !== uppyFileProgress) {
          $store.commit('clipboard/REPLACE_FILE', ClipboardFile.createFromUppyFile(uppyFile))
        }
      })
      .on('file-removed', (file) => {
        const $store = app.config.globalProperties.$store

        // will be called on uppy destroy, so we remove all uncompleted upload files from vuex store
        if (!file.progress.uploadComplete) {
          $store.commit('clipboard/REMOVE_FILE', ClipboardFile.createFromUppyFile(file))
        }
      })

    app.config.globalProperties.$clipboardUppy = clipboardUppy
  },
}
